import "./ModalsHeader.scss";
import { Button } from "@/components";
import * as Dialog from "@radix-ui/react-dialog";
import { Close } from "@/icons";

type ModalsHeaderProps = {
  title: string;
  closeButton: string;
  onCloseClick: () => void;
};

export const ModalsHeader = ({
  title,
  closeButton,
  onCloseClick,
}: ModalsHeaderProps) => {
  return (
    <header className="ui-modal-header ">
      <Dialog.Title className="base-col justify-content-center align-items-center mb-5 pb-x8">
        {title && <div className={"fw-bold fs-7 md-fs-custom"}>{title}</div>}
      </Dialog.Title>

      <Dialog.Close asChild className="ui-modal-header-close">
        <Button
          size="4"
          textColor="primary"
          bg="transparent"
          aria-label="Chiudi modale"
          onClick={onCloseClick}
        >
          {closeButton}
          <Close className="ml-x8" />
        </Button>
      </Dialog.Close>
    </header>
  );
};
